import { useState } from "react";
import { ChevronDown } from "lucide-react";
import type { ArticleFAQ } from "../../data/articles";

export function ArticleFaq({ faqs }: { faqs: ArticleFAQ[] }) {
  const [open, setOpen] = useState<number | null>(null);
  return (
    <section data-testid="article-faq" aria-labelledby="article-faq-title" className="mt-12">
      <h2 id="article-faq-title" className="text-xl font-semibold text-slate-100">Perguntas frequentes</h2>
      <div className="mt-5 divide-y divide-slate-800 rounded-xl border border-slate-800">
        {faqs.map((f, i) => {
          const expanded = open === i;
          const panelId = `faq-panel-${i}`;
          return (
            <div key={f.question}>
              <h3>
                <button
                  type="button"
                  id={`faq-button-${i}`}
                  aria-expanded={expanded}
                  aria-controls={panelId}
                  onClick={() => setOpen(expanded ? null : i)}
                  data-testid={`faq-toggle-${i}`}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left text-sm font-medium text-slate-100 transition-colors duration-200 hover:text-emerald-400 focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-emerald-500 sm:text-base"
                >
                  {f.question}
                  <ChevronDown aria-hidden="true" className={`h-4 w-4 shrink-0 text-emerald-500 transition-transform duration-200 ${expanded ? "rotate-180" : ""}`} />
                </button>
              </h3>
              <div id={panelId} role="region" aria-labelledby={`faq-button-${i}`} hidden={!expanded} data-testid={`faq-panel-${i}`} className="px-5 pb-5 text-sm leading-relaxed text-slate-300">
                {f.answer}
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
